module.exports = __webpack_public_path__ + "img/doc_cp2.afa40181.png";